import { Injectable } from '@angular/core';
import { mode, pad, enc, AES } from 'crypto-js';

@Injectable({
  providedIn: 'root'
})
export class EncryptionService {
  constructor() {}
  
  // Method to encrypt data for session storage
  /**
   * Encrypts data using AES-256 encryption
   * @param input - Data object to encrypt
   * @returns Encrypted string
   */
  encryptUsingAES256(input) {
    // console.log('[Session Storage] Encrypting data:', JSON.stringify(input).substring(0, 100) + '...');
    let _key = enc.Utf8.parse("493531ea-22e8-431c-9c27-4a5ea194343e");
    let _iv = enc.Utf8.parse("cac782ee-d9c4-45a9-ba0e-d99145d49739");
    let encrypted = AES.encrypt(
      JSON.stringify(input), _key, {
      keySize: 16,
      iv: _iv,
      mode: mode.ECB,
      padding: pad.Pkcs7
    });
    // console.log('[Session Storage] Encryption completed, length:', encrypted.toString().length);
    return encrypted.toString();
  }

  /**
   * Decrypts AES-256 encrypted data
   * @param ciphertext - Encrypted string
   * @returns Decrypted data object
   */
  decryptUsingAES256(ciphertext) {
    // console.log('[Session Storage] Decrypting data, length:', ciphertext.length);
    let _key = enc.Utf8.parse("493531ea-22e8-431c-9c27-4a5ea194343e");
    let _iv = enc.Utf8.parse("cac782ee-d9c4-45a9-ba0e-d99145d49739");
    let bytes = AES.decrypt(ciphertext, _key, {
      keySize: 16,
      iv: _iv,
      mode: mode.ECB,
      padding: pad.Pkcs7
    });
    const decrypted = JSON.parse(bytes.toString(enc.Utf8));
    // console.log('[Session Storage] Decryption completed:', Object.keys(decrypted).join(', '));
    return decrypted;
  }
}
